import script from "./CoursePurchase.vue?vue&type=script&setup=true&lang=ts"
export * from "./CoursePurchase.vue?vue&type=script&setup=true&lang=ts"

import "./CoursePurchase.vue?vue&type=style&index=0&id=85fbe2e0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85fbe2e0"]])

export default __exports__